const initialState = { isLoading: true, cms: [], requestMake: false };
export const FETCH_CMS_STATIC = 'FETCH_CMS_STATIC';
export const FETCH_CMS_STATIC_SUCCESS = `${FETCH_CMS_STATIC}_SUCCESS`;
export const FETCH_CMS_STATIC_FAIL = `${FETCH_CMS_STATIC}_FAIL`;

const CmsStaticReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_CMS_STATIC:
      return { ...state, isLoading: true, requestMake: true };
    case FETCH_CMS_STATIC_SUCCESS:
      return {
        ...state,
        isLoading: false,
        cms: {
          ...action.payload.data,
          categoryMenu: [
            ...action.payload.data.categoryMenu
          ],
        },
      };
    case FETCH_CMS_STATIC_FAIL:
      return { ...state, isLoading: false, error: action.error };
    default:
      return { ...state };
  }
};

export default CmsStaticReducer;
